"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _NotificationEnablePanelWrapper = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/NotificationEnablePanelWrapper"));

var _validation = require("@insided/shared/utils/validation");

var _biConnectorUtils = require("@insided/deprecated-control/integrations/components/bi-tools-connector/biConnectorUtils");

var _NotificationInputField = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/NotificationInputField"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EnableForEmail = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EnableForEmail, _Component);

  var _super = _createSuper(EnableForEmail);

  function EnableForEmail() {
    var _this;

    (0, _classCallCheck2.default)(this, EnableForEmail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      error: {
        email: '',
        label: ''
      },
      canSaveData: false,
      label: '',
      email: '',
      canBeEnabled: false,
      isEnabled: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIsEnabled", function (isEnabled) {
      _this.setState({
        isEnabled: isEnabled
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clearFields", function () {
      _this.setState({
        label: '',
        email: '',
        canSaveData: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLabelChange", function (value) {
      if (value !== '') {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            label: value,
            canSaveData: prevState.email !== '' && value !== '' && (0, _validation.isEmailValid)(prevState.email),
            canBeEnabled: prevState.email !== '' && value !== '',
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              label: ''
            })
          });
        });
      } else {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            canSaveData: false,
            label: '',
            canBeEnabled: false,
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              label: 'Label cannot be empty'
            })
          });
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEmailChange", function (value) {
      if (value !== '') {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            canSaveData: prevState.label !== '' && value !== '' && (0, _validation.isEmailValid)(value),
            email: value,
            canBeEnabled: prevState.label !== '' && value !== '',
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              email: ''
            })
          });
        });
      } else {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            canSaveData: false,
            email: '',
            canBeEnabled: false,
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              email: 'Email cannot be empty'
            })
          });
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEmailBlur", function () {
      if (_this.state.email !== '' && !(0, _validation.isEmailValid)(_this.state.email)) {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              email: 'Invalid Email'
            }),
            canSaveData: false
          });
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(EnableForEmail, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.props.targets.find(function (target) {
        if (target.type === 'email') {
          _this2.setState({
            label: target.label,
            email: target.config.endpoint,
            canSaveData: true,
            canBeEnabled: !!(target.label && target.config.endpoint),
            isEnabled: target.active
          });

          return true;
        }

        return false;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          label = _this$state.label,
          email = _this$state.email,
          error = _this$state.error;
      var requestState = this.props.requestState;
      var fields = [{
        label: 'Label',
        required: true,
        element: (0, _preact.h)(_NotificationInputField.default, {
          type: "text",
          value: label,
          error: error.label,
          disabled: requestState.type === 'info',
          placeholder: "Name",
          onInputChange: this.handleLabelChange
        })
      }, {
        label: 'Email',
        required: true,
        element: (0, _preact.h)(_NotificationInputField.default, {
          type: "email",
          value: email,
          error: error.email,
          placeholder: "Email",
          disabled: requestState.type === 'info',
          onInputChange: this.handleEmailChange,
          onBlur: this.handleEmailBlur
        })
      }];
      return (0, _preact.h)(_NotificationEnablePanelWrapper.default, {
        title: "Enable for Email",
        header: "Input Label and email id to configure notifications for Email",
        inputFields: fields,
        getData: function getData() {
          return (0, _biConnectorUtils.getEmailNotificationData)(_this3.state, _this3.props);
        },
        canSaveData: this.state.canSaveData,
        clearFields: this.clearFields,
        notificationType: "email",
        canBeEnabled: this.state.canBeEnabled,
        requestState: this.props.requestState,
        setRequestState: this.props.setRequestState,
        isEnabled: this.state.isEnabled,
        setIsEnabled: this.setIsEnabled
      });
    }
  }]);
  return EnableForEmail;
}(_preact.Component);

var _default = EnableForEmail;
exports.default = _default;